<!-- 座席種類 -->
<template>
  <div
    class="row"
    v-if="displaySeatExclusiveCarName"
  >
    <div class="th cell">座席種類</div>
    <div class="cell">{{ displaySeatExclusiveCarName }}</div>
  </div>
  <div
    class="row"
    v-else
    v-for="(seatType, index) in displaySeatAttributesLabelArray"
    :key="index"
  >
    <div class="th cell" v-if="index == 0">座席種類</div>
    <div class="th cell" v-else></div>
    <div class="cell">{{ seatType }}</div>
  </div>
</template>

<script>
export default {
  name: "StoreSeatType",
  props: {
    selectedSeatType: {
      type: String,
      required: false,
      default: null,
    },
    selectedSeats: {
      type: Array,
      required: false,
      default: null,
    },
    selectedExclusiveCars: {
      type: Array,
      required: false,
      default: null,
    },
  },
  computed: {
    displaySeatAttributesLabelArray() {
      // まずseat_attributeが異なってもラベルが同じ場合があるので、ラベルで区別するためにラベル文字列を配列に集める
      let seatLabelArray = [];
      if (this.selectedSeats) {
        seatLabelArray = this.selectedSeats.map((seat) =>
          this.displayMfittSeatAttribute(seat.seat_attribute)
        );
      } else if (this.selectedSeatType) {
        // 購入・予約前確認画面では唯一選択した席種類の文字列のみ渡ってくるのでそれをpush
        seatLabelArray.push(this.selectedSeatType);
      }
      console.log("seatLabelArray :>> ", seatLabelArray);

      // そこから重複した値を削除して返す
      return seatLabelArray.filter(
        (element, index, self) => self.findIndex((e) => e === element) === index
      );
    },
    displaySeatExclusiveCarName() {
      return this.displaySeatExclusiveCar(this.selectedExclusiveCars, this.selectedSeats);
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  display: table;
  font-size: 13px;
}
.row {
  display: table-row;
}

.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
  padding-right: 14px;
}
.arrow {
  width: 10px;
  height: auto;
  padding: 0 6px 1px 6px;
}
</style>
